import { FormItemTypes } from 'rds'

const DISCOUNTS_CATEGORY = Object.freeze({
    en: 'Discounts',
    es: 'Descuentos',
})
const ERROR_MESSAGES_CATEGORY = Object.freeze({
    en: 'Error messages',
    es: 'Mensajes de error',
})

const props = [
    {
        label: {
            en: 'Enable',
            es: 'Habilitar',
        },
        name: 'showDiscountCodeInput',
        type: FormItemTypes.CHECKBOX,
        category: DISCOUNTS_CATEGORY,
    },
    {
        label: {
            en: 'Input placeholder',
            es: 'Etiqueta del campo',
        },
        name: 'discountCodeLabel',
        type: FormItemTypes.TEXT,
        category: DISCOUNTS_CATEGORY,
    },
    {
        label: {
            en: 'Button label',
            es: 'Etiqueta del botón',
        },
        name: 'discountCodeButtonLabel',
        type: FormItemTypes.TEXT,
        category: DISCOUNTS_CATEGORY,
    },
    {
        label: {
            en: 'No shipments zone',
            es: 'Zona sin envíos',
        },
        name: 'noShipmentLabel',
        type: FormItemTypes.TEXT,
        category: ERROR_MESSAGES_CATEGORY,
    },
]

export default props
